import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FiberNewIcon from "@mui/icons-material/FiberNew"; // For "new" trend
import { Box } from "@mui/material";

interface TrendProps {
    trend: "up" | "down" | "steady" | "new";
    showSteady?: boolean
}

const Trend: React.FC<TrendProps> = ({ trend, showSteady = true }) => {
    const renderIcon = () => {
        switch (trend) {
            case "up":
                return <ArrowUpwardIcon color="success" />;
            case "down":
                return <ArrowDownwardIcon color="error" />;
            case "steady":
                return showSteady ? <ArrowForwardIcon color="action" /> : "";
            case "new":
                return <FiberNewIcon color="primary" />;
            default:
                return null;
        }
    };

    return <Box display="flex" alignItems="center">{renderIcon()}</Box>;
};

export default Trend;
